<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="containerBox" id="toTop">
        <div class="headerBox">
          <div class="top">
            <div class="searchBox" @click.stop="$router.push('/search')">
              <img class="searchIcon" src="@/assets/images/search_comm_icon@2x.png" />
              <span class="searchInput">请输入关键字搜索</span>
            </div>
          </div>
          <div class="classify">
            <div class="classify_content" ref="wrapper">
              <div class="classify_wrapper">
                <span :class="{'active_classify': departmentId == 0}" @click="changeDepartment(0, '')">
                  <template v-if="userInfo.Type != 3">全部</template>
                  <template v-if="userInfo.Type == 3">ALL</template>
                </span>
                <span :class="{'active_classify': departmentId == item.Id}" v-for="(item, index) in navBar" :key="index" @click="changeDepartment(item.Id, item.Code)">{{item.DisplayName}}</span>
              </div>
            </div>
            <div class="more">
              <router-link to="/interest">
                <img class="addIcon" src="@/assets/images/ellipsis.png" />
                <span>{{userInfo.Type != 3 ? '更多科室' : 'More'}}</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="banner" v-if="bannerList.length > 0">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#CA001B">
              <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="imgclick(item)">
                <img class="bannerImg" :src="item.File_Url" />
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="titleBox">
            <div class="moduleTitle">
              <img src="@/assets/images/live_list_icon.png" />
              <span class="liveTitle">
                <template v-if="userInfo.Type != 3">直播</template>
                <template v-if="userInfo.Type == 3">Live</template>
              </span>
              <span>({{ Total }})</span>
            </div>
            <div style="position: relative; left: 20px;">
              <div class="allBox" :class="{'active': activeColumn == 1}" @click="changeColumn(1)">
                <span v-if="DayType == null">ALL</span>
                <span v-if="DayType == 1">≤7Days</span>
                <span v-if="DayType == 2">≤1Days</span>
                <img class="column_icon1" @click.stop="showDayType = !showDayType" :src="activeColumn == 1 ? require('@/assets/images/caretIcon.png') : require('@/assets/images/caretIcon_active.png')" />
              </div>
              <div class="daysBox" v-if="showDayType">
                <div class="dayItem" v-if="DayType != null" @click="changeDayType(null)">ALL</div>
                <div class="dayItem" v-if="DayType != 1" @click="changeDayType(1)">≤7Days</div>
                <div class="dayItem" v-if="DayType != 2" @click="changeDayType(2)">≤1Days</div>
              </div>
            </div>
          </div>
          <div class="columnBox">
            <!-- <div style="position: relative;">
              <div class="column_item" :class="{'active': activeColumn == 1}" @click="changeColumn(1)">
                <span v-if="DayType == null">ALL</span>
                <span v-if="DayType == 1">≤7Days</span>
                <span v-if="DayType == 2">≤1Days</span>
                <img class="column_icon1" @click.stop="showDayType = !showDayType" :src="activeColumn == 1 ? require('@/assets/images/caretIcon.png') : require('@/assets/images/caretIcon_active.png')" />
              </div>
              <div class="daysBox" v-if="showDayType">
                <div class="dayItem" v-if="DayType != null" @click="changeDayType(null)">ALL</div>
                <div class="dayItem" v-if="DayType != 1" @click="changeDayType(1)">≤7Days</div>
                <div class="dayItem" v-if="DayType != 2" @click="changeDayType(2)">≤1Days</div>
              </div>
            </div> -->
            <div class="column_item" @click="$router.push('/activityList?id=0')">
              <img class="column_icon4" src="@/assets/images/activityIcon.png" />
              <span v-if="userInfo.Type != 3">活动专区</span>
              <span class="column_font_en" v-if="userInfo.Type == 3">Events</span>
            </div>
            <div class="column_item" :class="{'active': activeColumn == 2}" @click="changeColumn(2)">
              <img class="column_icon2" :src="activeColumn == 2 ? require('@/assets/images/calendarIcon.png') : require('@/assets/images/calendarIcon_active.png')" />
              <span v-if="userInfo.Type != 3">日历</span>
              <span class="column_font_en" v-if="userInfo.Type == 3">Calendar</span>
            </div>
            <div class="column_item" :class="{'active': activeColumn == 3}" @click="changeColumn(3)">
              <img class="column_icon3" :src="activeColumn == 3 ? require('@/assets/images/labelIcon.png') : require('@/assets/images/labelIcon_active.png')" />
              <span v-if="userInfo.Type != 3">我的预约</span>
              <span class="column_font_en" v-if="userInfo.Type == 3">Booking</span>
            </div>
            <div class="column_item" :class="{'active': activeColumn == 4}" @click="changeColumn(4)">
              <img class="column_icon3" :src="activeColumn == 4 ? require('@/assets/images/starIcon.png') : require('@/assets/images/starIcon.png')" />
              <span v-if="userInfo.Type != 3">星光直播</span>
              <span class="column_font_en" v-if="userInfo.Type == 3">XingGuang</span>
            </div>
          </div>
          <div id="dataList">
            <template v-if="activeColumn != 3">
              <waterfall ref="waterfall" :col="2" :gutterWidth="10" :data="list">
                <template>
                  <div class="list" v-for="(item, index) in list" :key="index" @click="toContentPage(item.Id, item.Type)">
                    <div class="item_img">
                      <img class="item_cover" :src="item.Thumbnail" />
                      <span class="activityLabel" v-if="item.Type == 4">系列活动</span>
                      <!-- <span class="endLabel" v-if="item.status == 4">已结束</span> -->
                    </div>
                    <div class="item_content">
                      <span class="item_title van-multi-ellipsis--l2">{{item.Title}}</span>
                      <div class="doctor_info" v-if="item.Speaker || item.HospitalName">
                        {{item.Speaker}} <span v-if="item.HospitalName">|</span> {{item.HospitalName}}
                      </div>
                      <!-- <div class="item_flexbox">
                        <p class="item_time" v-if="item.StartTime">{{item.StartTime.split('T')[0]}}</p>
                      </div> -->
                    </div>
                  </div>
                </template>
              </waterfall>
            </template>
            <template v-else>
              <div class="timeline">
                <div class="timeline-item" v-for="(item, index) in list" :key="index">
                  <div class="timeline-marker"></div>
                  <div class="timeline-content">
                    <span class="live-time">{{ item.StartTime | timeStartFormat }}</span>
                    <div class="live-item" @click="toContentPage(item.Id, item.Type)">
                      <div class="live-cover">
                        <img :src="item.Thumbnail" alt="">
                      </div>
                      <div class="live-info">
                        <p class="live-title van-multi-ellipsis--l2">{{ item.Title }}</p>
                        <p class="live-doctor" v-if="item.Speaker">主治医师：{{ item.Speaker }}</p>
                        <span class="endLabel" v-if="item.status == 4">已结束</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </mescroll-vue>
    <van-overlay :show="calendarShow">
      <div class="calendarOverlayBox" @click.stop>
        <div class="calendarBox">
          <Calendar :selectedDate="selectedDate" :dataDates="dataDates" @select-day="handleSelectDay" @change-month="handleChangeMonth" />
          <div class="handle">
            <div class="btn cancel" @click="calendarCancel">取消</div>
            <div class="btn confirm" @click="calendarConfirm">确认</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Calendar from '../../components/Calendar.vue';
export default {
  name: 'LiveList',
  data() {
    return {
      bannerList: [],
      activeColumn: 1,
      showDayType: false,
      DayType: null,
      code: '',
      departmentId: 0,
      time: '',
      list: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 6 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '敬请期待', // 提示
        },
			},
      calendarShow: false,
      selectedDate: new Date(),
      confirmdDate: new Date(),
      dataDates: []
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    Calendar
  },
  watch: {
    navBar(newVal) {
      if(this.code && !newVal.some(obj => obj.Code == this.code)) {
        this.departmentId = 0;
        this.code = '';
        this.list = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
        this.miniProgramShare(this.departmentId, this.code);
      }
      this.$nextTick(() => {
        this.scroll.refresh();
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  created() {
    if(this.userInfo && this.userInfo.Id) {
      this.getNavbar();
    }
    this.getBanner();
    this.$store.commit("changeNavbarIndex", 1);

    let date = new Date();
    this.time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.getHasData(date);
  },
  mounted() {
    this.initBScroll();
  },
  activated(){
    if(this.$route.query.code) {
      this.code = this.$route.query.code;
    }
    if(this.$route.query.id) {
      this.departmentId = this.$route.query.id;
    }
    this.miniProgramShare(this.departmentId, this.code);
    this.BuriedPoint(6, '直播', '', '/liveList?id=0');
    this.$store.commit('changeNavbarIndex', 1);
  },
  methods: {
    // 初始化BScroll
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    // 获取Banner
    getBanner() {
      this.$axios.get('/Api/api/Web/ImgFile/GetImgFileListByCode?Code=zbzq').then(res => {
        this.bannerList = res.Data;
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    // 获取列表数据
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetNewLiveList', {
          // code: this.code,
          SubId: this.departmentId != 0 ? parseInt(this.departmentId) : null,
          time:this.time,
          IsIntraday: this.activeColumn,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          DayType: this.DayType
        }).then((res) => {
          let arr = res.Data.List;
          this.Total = res.Data.Total;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = arr;
          let hasNext;
          if(arr.length < this.Total) {
            hasNext = true;
          } else {
            hasNext = false;
          }
          // this.list = this.list.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length, hasNext)
          })
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    miniProgramShare(id, code) {
      if(id && code) {
        wx.miniProgram.postMessage({
          data: {
            share: {
              title: '科室直播',
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/liveList?id=${id}&&code=${code}`)}`,
              contentId: ''
            }
          }
        })
      } else {
        wx.miniProgram.postMessage({
          data: {
            share: {
              title: '直播',
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + '/liveList?id=0')}`,
              contentId: ''
            }
          }
        })
      }
    },
    changeDepartment(id, code) {
      if(this.departmentId != id && this.code != code) {
        this.departmentId = id;
        this.code = code;
        this.miniProgramShare(this.departmentId, this.code);
        this.list = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
        this.getHasData(this.confirmdDate);
      }
    },
    changeColumn(type) {
      if(this.activeColumn != type && type == 1) {
        this.activeColumn = type;
        let date = new Date();
        this.time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        this.list = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      } else if(type == 2) {
        this.calendarShow = true;
      } else {
        if(type == 4) {
          wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
        } else if(this.activeColumn != type) { 
          this.activeColumn = type;
          this.list = [];
          this.mescroll.resetUpScroll() // 刷新列表数据
        }
      }
      this.showDayType = false;
    },
    getHasData(date) {
      // console.log('第一天-----',new Date(date.getFullYear(), date.getMonth(), 1));
      // console.log('最后一天-----',new Date(date.getFullYear(), date.getMonth() + 1, 0));
      let StartTime = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
      let EndTime = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
      this.$axios.post('/Api/api/Web/Article/GetMonthLiveCount', {
        StateTime: StartTime,
        EndTime: EndTime,
        code: this.code
      }).then(res => {
        this.dataDates = res.Data;
      })
    },
    handleSelectDay(date) {
      this.selectedDate = date;
      if(date) {
        const dateString = date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
        console.log(`你选择的日期是: ${dateString}`);
      }
    },
    handleChangeMonth(date) {
      this.getHasData(date);
    },
    calendarCancel() {
      this.calendarShow = false;
      this.selectedDate = this.confirmdDate;
    },
    calendarConfirm() {
      this.activeColumn = 2;
      this.confirmdDate = this.selectedDate;
      let confirmdDate = new Date(this.confirmdDate);
      this.time = confirmdDate.getFullYear() + '-' + (confirmdDate.getMonth() + 1) + '-' + confirmdDate.getDate();;
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
      this.calendarShow = false;
    },
    toContentPage(id, type) {
      if(type == 4) {
        this.$router.push({
          path: 'activityDetails',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      }
    },
    changeDayType(type) {
      this.activeColumn = 1;
      this.DayType = type;
      this.showDayType = false;
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    imgclick(info) {
      if(info.LinkType && info.UrlLink) {
        if(info.LinkType == 1) {
          let objExp=new RegExp(/^(f|ht)tps?:\/\//i);
          if(objExp.test(info.UrlLink)) {
            location.href = info.UrlLink;
          } else {
            this.$router.push(info.UrlLink);
          }
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.UrlLink})
        } else if(info.LinkType == 3) {
          if (info.UrlLink.indexOf('?') !== -1) {
            info.UrlLink += '&sourceType=3&sourceId=' + info.Id;
          } else {
            info.UrlLink += '?sourceType=3&sourceId=' + info.Id;
          }
          this.$router.push(info.UrlLink);
        }
      }
      this.BuriedPoint(3, info.DepartmentName, info.DepartmentCode, info.UrlLink, info.Id);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background-color: #F9F9F9;
  .headerBox {
    padding-top: 16px;
    background-color: #EB1701;
  }
  .mescroll {
    position: fixed;
    top: 0;
    bottom: 60px;
    height: auto;
  }
  .top {
    margin-bottom: 10px;
    display: flex;
    padding: 0 12px;
    .menuIcon {
      width: 30px;
      height: 30px;
    }
    .searchBox {
      display: flex;
      align-items: center;
      flex: 1;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      background-color: #FFFFFF;
      padding: 0 12px;
      .searchIcon {
        width: 16px;
        height: 16px;
      }
      .searchInput {
        flex: 1;
        margin-left: 5px;
        border: none;
        background-color: transparent;
        color: #999999;
      }
    }
  }
  .classify {
    display: flex;
    color: #FFFFFF;
    height: 31px;
    padding: 0 12px;
    .classify_content {
      display: flex;
      flex: 1;
      font-size: 14px;
      overflow: hidden;
      .classify_wrapper {
        white-space: nowrap;
        span {
          position: relative;
        }
        span:not(:last-child) {
          margin-right: 20px;
        }
        .active_classify {
          font-size: 18px;
          font-weight: bold;
        }
        .active_classify::after {
          content: "";
          width: 22px;
          height: 3px;
          border-radius: 3px;
          background-color: #FFFFFF;
          position: absolute;
          top: 24px;
          left: 50%;
          transform: translateX(-11px);
        }
      }
    }
    .more {
      font-size: 12px;
      margin-left: 10px;
      a {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        margin-top: 6px;
      }
      .addIcon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
      span {
        opacity: 0.8;
      }
    }
  }
  .content {
    min-height: 100%;
    margin-top: 1px;
    padding: 12px 12px 0;
    background-color: #F9F9F9;
  }
  .content:before{
    content: '';
    display: table;
  }
  .banner {
    margin: 3px 0 15px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    overflow: hidden;
    .bannerImg {
      width: 100%;
      display: block;
    }
  }
  .titleBox {
    display: flex;
    align-items: center;
    .active {
      border: none;
      color: #FFFFFF;
      background: linear-gradient(to right, #EB1700 0%, #C33BBB 80%, #8C3BBB 100%);
    }
  }
  .moduleTitle {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    img {
      display: block;
      width: 22px;
      margin-right: 6px;
    }
    .liveTitle {
      color: transparent;
      background-image: linear-gradient(to right, #EB1700 40%, #C33BBB 60%, #8C3BBB 100%);
      background-clip: text;
      -webkit-background-clip: text;
    }
    span {
      color: #CA001A;
    }
  }
  .allBox {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 60px;
    height: 24px;
    border-radius: 24px;
    border: 1px solid #CCCCCC;
    background-color: #FFFFFF;
    font-size: 13px;
    color: #CA001A;
    box-sizing: border-box;
    padding: 0 6px;
    .column_icon1 {
      display: block;
      width: 11px;
      margin-left: 2px;
    }
  }
  .daysBox {
    position: absolute;
    top: 24px;
    left: 0;
    right: 0;
    z-index: 100;
    border: 1px solid #CCCCCC;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 0 0 18px 0;
    .dayItem {
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 13px;
      color: #CA001A;
    }
    .dayItem:not(:last-of-type) {
      border-bottom: 1px solid #CCCCCC;
      border-radius: 0 0 18px 0;
    }
  }
  .columnBox {
    display: flex;
    justify-content: space-between;
    margin: 15px 0;
    .column_item {
      flex: 1;
      position: relative;
      z-index: 99;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 80px;
      height: 30px;
      border: 1px solid #CCCCCC;
      background-color: #FFFFFF;
      border-radius: 32px 0 32px 32px;
      // padding: 0 10px;
      box-sizing: border-box;
      font-size: 13px;
      color: #CA001A;
    }
    .column_item:not(:last-child) {
      margin-right: 8px;
    }
    .column_item_en {
      position: relative;
      z-index: 99;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      border: 1px solid #CCCCCC;
      background-color: #FFFFFF;
      border-radius: 32px 0 32px 32px;
      padding: 0 5px;
      box-sizing: border-box;
      font-size: 13px;
      color: #CA001A;
    }
    .column_item_en:not(:last-child) {
      margin-right: 5px;
    }
    .column_icon1 {
      display: block;
      width: 11px;
      margin-left: 2px;
    }
    .column_icon2 {
      display: block;
      width: 17px;
      margin-right: 1px;
    }
    .column_icon3 {
      display: block;
      width: 15px;
      margin-right: 1px;
    }
    .column_icon4 {
      display: block;
      width: 14px;
      margin-right: 3px;
    }
    .column_font_en {
      font-size: 11px;
    }
    .active {
      border: none;
      color: #FFFFFF;
      background: linear-gradient(to right, #EB1700 0%, #C33BBB 80%, #8C3BBB 100%);
    }
  }
  .list {
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 10px;
    .item_img {
      position: relative;
      .item_cover {
        display: block;
        width: 100%;
      }
      .playIcon {
        position: absolute;
        right: 3px;
        bottom: 3px;
        width: 20px;
        height: 20px;
      }
      .endLabel {
        display: inline-block;
        padding: 0 2px;
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 9px;
        background-color: #E8E8E8;
      }
      .activityLabel {
        display: inline-block;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 8px;
        color: #FFFFFF;
        background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
        border-radius: 0 0 0 8px;
      }
    }
    .item_content {
      padding: 5px 8px;
      color: #564C47;
      .item_title {
        font-size: 14px;
      }
      .doctor_info {
        font-size: 11px;
        margin-top: 5px;
        span {
          color: #999999;
        }
      }
      .item_flexbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .item_time {
        font-size: 12px;
        line-height: 24px;
      }
      .item_label {
        display: flex;
        flex-wrap: wrap;
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          border-radius: 2px;
          padding: 0 6px;
          margin-right: 6px;
          margin-bottom: 5px;
          background-color: rgba(255, 73, 98, 0.15);
          font-size: 11px;
          color: #CA001B;
        }
      }
      .item_nums {
        display: flex;
        justify-content: flex-end;
        .nums {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            margin: 0 2px 0 6px;
          }
          span {
            font-size: 11px;
          }
        }
      }
    }
  }
  .timeline {
    width: 100%;
    margin: 0 auto;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .timeline-item {
    display: flex;
    margin-bottom: 20px;
    position: relative;
    // border: 1px solid red;
  }
  .timeline-marker {
    width: 8px;
    height: 8px;
    background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
    border-radius: 50%;
    margin-right: 8px;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    align-self: center; /* 节点上下居中 */
  }
  .timeline-content {
    display: flex;
    align-items: center;
    flex: 1;
    .live-time {
      width: 64px;
      margin-right: 4px;
      color: #E20000;
      font-size: 12px;
      font-weight: bold;
    }
    .live-item {
      display: flex;
      flex: 1;
      background-color: #FFFFFF;
      box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
      padding: 6px 7px;
      border-radius: 8px;
      .live-cover {
        width: 40%;
        margin-right: 6px;
        img {
          display: block;
          width: 100%;
        }
      }
      .live-info {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        .live-title {
          font-size: 13px;
        }
        .live-doctor {
          font-size: 11px;
        }
        .endLabel {
          display: inline-block;
          padding: 0 2px;
          position: absolute;
          right: 0px;
          bottom: 0px;
          font-size: 9px;
          background-color: #E8E8E8;
        }
      }
    }
  }
  .timeline-item::before {
    content: '';
    position: absolute;
    left: 3px;
    top: 50%;
    width: 1px;
    height: calc(100% + 22px);
    background: repeating-linear-gradient(
      to bottom,
      transparent,
      transparent 4px,
      #CA001A 5px,
      #CA001A 10px
    );
    z-index: 0;
  }
  .timeline-item:last-child::before {
    display: none;
  }
  .timeline-content {
    flex: 1;
  }
}
.calendarOverlayBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 12px;
  .calendarBox {
    background-color: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
  }
  .handle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15%;
    margin: 10px 0 15px;
    .btn {
      width: 90px;
      height: 34px;
      line-height: 34px;
      border-radius: 34px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }
    .cancel {
      color: #CA001A;
      background-image: url('../../assets/images/btn_bg2.png');
      background-size: 100% 100%;
    }
    .confirm {
      color: #FFFFFF;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
    }
  }
}
</style>